<template>
	<div class="authority_error_code">
		<div style="width: 570px;">
			<template>
			    <el-table
				    :data="tableData"
				    :span-method="objectSpanMethod"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="Code"
					        width="120px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="Msg"
				        	width="450px">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template>
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				tableData:[
					{
						"code":"5001",
						"msg":"注册成功",
						
					},
					{
						"code":"5002",
						"msg":"图像质量低，请在明亮顺光环境中录入",
						
						
					},
					{
						"code":"5003",
						"msg":"人脸角度不准，请按照要求转动头部",
						
						
					},
					{
						"code":"5004",
						"msg":"请勿录入不同人脸",
						
					},
					{
						"code":"5005",
						"msg":"请靠近摄像头一定距离",
						
						
					},
					{
						"code":"5006",
						"msg":"请远离摄像头一定距离",
						
						
					},
					{
						"code":"5007",
						"msg":"注册信息保存失败",
					
						
					},
					{
						"code":"5007",
						"msg":"请正视摄像头",
						
						
					},
					{
						"code":"5008",
						"msg":"请正视摄像头",
						
						
					},
					{
						"code":"5009",
						"msg":"姓名不能为空、姓名不能超过20字、姓名不能包含特殊字符",
						
						
					},
					{
						"code":"5010",
						"msg":"生日不能为空、无效的生日",
						
						
					},
					{
						"code":"5011",
						"msg":"性别不能为空、无效的性别",
						
						
					},
					{
						"code":"5012",
						"msg":"注册有效区域信息有误",
					
					},
					{
						"code":"5013",
						"msg":"数据库容量不足",
						
					},
					{
						"code":"5014",
						"msg":"ERROR507",
						"meaning":"请先初始化成功并正常检测后调用",
						
					},
					{
						"code":"5015",
						"msg":"内部调用错误",
						
					},
					{
						"code":"4001",
						"msg":"注册超时请重新注册",
					},
				
				],
			}
		},
		methods:{
			objectSpanMethod({ row, column, rowIndex, columnIndex }){
				console.log(row, column, rowIndex, columnIndex)
		  		if (row.colspan) {
			        if (columnIndex === 1) {
			            return [1, 2];
			        } else if (columnIndex === 2) {
			            return [0, 0];
			        }
		        }	
			}
		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.authority_error_code{
		//margin:5px 0 30px 30px;
		margin:5px 0 30px 0;
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				text-align: left;
				.table_msg_list{
					padding: 2px 0;
				}
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/Registrationstatus.vue